import { render, staticRenderFns } from "./KiruaPage.vue?vue&type=template&id=0222f4d4"
import script from "./KiruaPage.vue?vue&type=script&lang=js"
export * from "./KiruaPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports